import { actions } from './actions'

const initialState = {
  ladrones: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function ladronesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LADRONES_LOAD_REQUESTED:
      return { ...state, ladrones: { ...state.ladrones, loading: true } }
    case actions.LADRONES_LOAD_SUCCEEDED:
      return {
        ...state,
        ladrones: { ...state.ladrones, data: action.payload, loading: false },
      }
    case actions.LADRONES_LOAD_FILED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: false, error: action.error },
      }
    case actions.LADRON_UPDATE_REQUESTED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: true, error: '' },
      }
    case actions.LADRON_UPDATE_SUCCEEDED:
      return {
        ...state,
        ladrones: {
          ...state.ladrones,
          data: state.ladrones.data.map(ladron =>
            ladron.id === action.payload.id ? action.payload : ladron,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.LADRON_UPDATE_FILED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: false, error: action.error },
      }
    case actions.LADRON_INSERT_REQUESTED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: true, error: '' },
      }
    case actions.LADRON_INSERT_SUCCEEDED:
      return {
        ...state,
        ladrones: {
          ...state.ladrones,
          data: [].concat(action.payload, state.ladrones.data),
          loading: false,
          error: '',
        },
      }
    case actions.LADRON_INSERT_FILED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: false, error: action.error },
      }
    case actions.LADRON_DELETE_REQUESTED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: true, error: '' },
      }
    case actions.LADRON_DELETE_SUCCEEDED:
      return {
        ...state,
        ladrones: {
          ...state.ladrones,
          data: state.ladrones.data.filter(pais => pais.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.LADRON_DELETE_FILED:
      return {
        ...state,
        ladrones: { ...state.ladrones, loading: false, error: action.error },
      }
    default:
      return state
  }
}
